import React, {Component} from 'react';
import { withRouter } from 'react-router-dom';
import SignOutButton from '../SignOut';
import Logo from "../Logo";
import * as routes from '../../constants/routes';
import withAuthorization from '../Session/withAuthorization';
import {auth} from '../../firebase'
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink
} from 'reactstrap';
import "./index.css";


class Navigation extends Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.navigationAdmin = this.navigationAdmin.bind(this);
    this.navigationUser = this.navigationUser.bind(this);

    this.state = {
      isAdmin:false,
      isOpen:false
    };
  }

  componentDidMount(){
    //refactor use store    
    auth.getCurrentUserToken().then(token =>{     
      if(token.claims.isAdmin){
        this.setState({
          isAdmin:true
        });
      }
    })
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  render(){
    if(this.state.isAdmin){
      return(
        this.navigationAdmin()
      )
    }
    else{
      return(
        this.navigationUser()
      )
    }
  }

  navigationAdmin() {
    return(
      <Navbar light expand="md" className="text-center">
      <NavbarBrand href="/"className="mr-auto"><Logo></Logo></NavbarBrand>
      <NavbarToggler onClick={this.toggle} />
      <Collapse isOpen={this.state.isOpen} navbar>
        <Nav className="mr-auto" navbar>
          <NavItem>
            <NavLink href={routes.CREATE_COMPLAIN}>Registruoti incidentą</NavLink>
          </NavItem>
          <NavItem>
            <NavLink href={routes.ADMIN}>Valdyti incidentus</NavLink>
          </NavItem>
          <NavItem>
            <NavLink href={routes.CREATE_USER}>Sukurti vartotoją</NavLink>
        </NavItem>
        <NavItem>
          <NavLink href={routes.ALL_USERS}>Valdyti vartotojus</NavLink>
        </NavItem>
        <Logout/>
        </Nav>
      </Collapse>
    </Navbar>
    )
  }

  navigationUser() {
    return (
      <Navbar light expand="md" className="text-center">
      <NavbarBrand href="/" className="mr-auto"><Logo></Logo></NavbarBrand>
      <NavbarToggler onClick={this.toggle} />
      <Collapse isOpen={this.state.isOpen} navbar>
        <Nav className="mr-auto" navbar>
          <NavItem>
            <NavLink href={routes.CREATE_COMPLAIN}>Registruoti incidentą</NavLink>
          </NavItem>
          <NavItem>
            <NavLink href={routes.ACCOUNT}>Mano incidentai</NavLink>
          </NavItem>
          <Logout/>
        </Nav>
      </Collapse>
    </Navbar>
    )
  }
}

const Logout = () =>
  <NavItem className="signOut-btn">
    <SignOutButton/>
  </NavItem>

const authCondition = (authUser) => !!authUser;

export default withAuthorization(authCondition)(withRouter(Navigation));



// WEBPACK FOOTER //
// ./src/components/Navigation/index.js